import Loading from '../../../Common/Loading';
import { useSchedulingChartsDataContext } from './hooks/useSchedulingChartsDataContext';
import { Indicators } from './Indicators';
import { AppointmentsBalance } from './AppointmentsBalance';
import { AppointmentsBySituations } from './AppointmentsBySituations';
import { TableScheduling } from './TableScheduling';

export const Charts = () => {
    const { isLoading } = useSchedulingChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Indicators />
            <div className="charts-side-by-side-dashboards">
                <AppointmentsBalance />
                <AppointmentsBySituations />
            </div>
            <div className="w-100">
                <TableScheduling />
            </div>
        </>
    );
};
